export const enum EButtonType {
  RectangleFilled,
  RoundedFilled,
  RectangleOutlined,
  RoundedOutlined,
}
